import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PermissionsService } from './permissions.service';
import { config } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class ExamFolderService {
  private apiUrl = `${config.examApiBaseUrl}/call`;

  constructor(private http: HttpClient, private permissionsService: PermissionsService) { }

  getFolders(): Observable<any> {
    const body = {
      procedureName: 'sp_GetCoursesWithUnits',
      params: {}
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  addFolder(courseName: string, courseUnits: string): Observable<any> {
    const body = {
      procedureName: 'sp_AddCourseWithUnits',
      params: {
        CourseName: courseName,
        UnitNames: courseUnits,
        CreatedBy: this.permissionsService.getUserId()
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  updateFolder(courseID: number, courseName: string, courseUnits: string): Observable<any> {
    const body = {
      procedureName: 'sp_UpdateCourseWithUnits',
      params: {
        CourseID: courseID,         
        CourseName: courseName, 
        UnitNames: courseUnits, 
        UpdatedBy:  this.permissionsService.getUserId()
      }
    };
  
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }
  
  getUnitsByCourseID(courseID: number): Observable<any> {
    const requestBody = {
      procedureName: "GetUnitsByCourseID",
      params: {
        CourseID: courseID
      }
    };
    return this.http.post(`${this.apiUrl}/get-units`, requestBody);
  }

  deleteFolder(courseID: number): Observable<any> {
    const body = {
      procedureName: 'sp_DeleteCourse',
      params: {
        CourseID: courseID,
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }
}
